import React from 'react';

const CTA = ({ lang }) => {
  const content = {
    ar: {
      title: "هل تحتاج إلى استشارة قانونية متخصصة؟",
      text: "نحن هنا لحماية حقوقك وتقديم الدعم اللازم لنمو أعمالك. لا تتردد في طلب المشورة من خبرائنا.",
      btn: "حجز موعد استشارة"
    },
    en: {
      title: "Need Expert Legal Advice?",
      text: "We are here to safeguard your rights and support your business growth. Do not hesitate to seek counsel from our experts.",
      btn: "Book a Consultation"
    }
  };

  const t = content[lang];
  const isAr = lang === 'ar';

  return (
    <section className="cta-section" dir={isAr ? 'rtl' : 'ltr'}>
      <div className="cta-overlay"></div>
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">{t.title}</h2>
          <p className="cta-text">{t.text}</p>
          <a href="#contact" className="cta-btn-gold">
            {t.btn}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;